import { jsx as _jsx } from "react/jsx-runtime";
export function TForm(props) { return /*#__PURE__*/ _jsx("form", { onSubmit: function (e) { e.preventDefault(); props.onSubmit(); }, style: props.style, children: props.children }); }
